import React from "react";
import { Card, CardContent, Typography, List, ListItem, ListItemText, ListItemIcon } from "@mui/material";
import WarningTwoToneIcon from '@mui/icons-material/WarningTwoTone';
import DangerousTwoToneIcon from '@mui/icons-material/DangerousTwoTone';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import { ValidacionMutuoResult } from "../../models/ValidacionMutuoResult";

interface Props {
  validaciones: ValidacionMutuoResult;
  titulo: string;
  grupoComparacion: string;
}

const CardValidaciones: React.FC<Props> = ({ validaciones, titulo, grupoComparacion }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h5">{titulo}</Typography>

        <List key={0} sx={{ mt: 0 }}>

        {validaciones?.businessRulesResults
          .filter((x) => x.group === grupoComparacion)
          .map((m, index) => (

              <>
                  {m.messageType === "Success" && m.aplicaRegla === true &&
                    <>
                        <ListItem sx={{ height: 15, mt: 2 }}>
                          <ListItemIcon>
                            <CheckCircleTwoToneIcon sx={{ color: "green" }}/>
                          </ListItemIcon>
                          <ListItemText primary={m.message} />
                        </ListItem>
                    </>
                  }

                  {m.messageType === "Error" && m.aplicaRegla === true &&
                    <>
                        <ListItem sx={{ height: 15, mt: 2 }}>
                          <ListItemIcon>
                            <DangerousTwoToneIcon sx={{ color: "red" }}/>
                          </ListItemIcon>
                          <ListItemText primary={m.message} />
                        </ListItem>
                    </>
                  }

                  {m.messageType === "Warning" && m.aplicaRegla === true &&
                    <>
                        <ListItem sx={{ height: 15, mt: 2 }}>
                          <ListItemIcon>
                            <WarningTwoToneIcon sx={{ color: "orange" }}/>
                          </ListItemIcon>
                          <ListItemText primary={m.message} />
                        </ListItem>
                    </>
                  }
              </>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default CardValidaciones;
